import React from 'react';
import PropTypes from 'prop-types';
import BaseDatepicker from 'components/atoms/base-datepicker';

const DatePicker = ({
  value,
  valueChanged,
  format: customFormat,
  disabled,
  maxDate,
}) => {
  return (
    <BaseDatepicker
      value={value}
      maxDate={maxDate}
      format={customFormat}
      disabled={disabled}
      onChange={(_, val) => valueChanged(val)}
    />
  );
};

DatePicker.propTypes = {
  value: PropTypes.string,
  format: PropTypes.string,
  valueChanged: PropTypes.func,
  disabled: PropTypes.bool,
  maxDate: PropTypes.instanceOf(Date),
};

export default DatePicker;
